module.exports = __webpack_public_path__ + "static/media/bufetowa.431a525a.jpg";